export const TECHNICAL_ERROR_PAGE = 'TECHNICAL_ERROR_PAGE';
export const INELIGIBILE_PAGE = 'INELIGIBILE_PAGE';
export const CUSTOMER_SEGMENT = 'CUSTOMER_SEGMENT';
